import { render, staticRenderFns } from "./ReceiptRedeem.vue?vue&type=template&id=74fc77f1&scoped=true&"
import script from "./ReceiptRedeem.vue?vue&type=script&lang=js&"
export * from "./ReceiptRedeem.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptRedeem.vue?vue&type=style&index=0&id=74fc77f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fc77f1",
  null
  
)

export default component.exports